import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-white py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-127" data-mp="1j9740qqiilye">
      <div className="mx-auto max-w-3xl px-4" data-id="element-128" data-mp="1n9ipg5qp8qax">
        <SectionHeading id="pricing-title" data-id="element-129" data-mp="1ncwr1brjgvhb">Choose Your <span className="text-teal-700" data-id="element-130" data-mp="1s8u5tdn5ltrz">Option</span></SectionHeading>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-amber-400 bg-white shadow-xl" data-id="element-131" data-mp="1x8zs0eanmo2o">
          <div className="border-b border-slate-200 bg-[#0A1B33] px-6 py-4 sm:px-10" data-id="element-132" data-mp="228crbyippnm5">
            <span className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-3 py-1 text-xs font-semibold text-[#0A1B33]" data-id="element-133" data-mp="2uyupxur694p">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-134" data-mp="7utkfy2skso6" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-135" data-mp="1mi99x2rwowj9">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-136" data-mp="1hpyb638wjgsa">
              <div data-id="element-137" data-mp="1cqv309xmkug3">
                <h3 className="text-2xl font-bold leading-tight tracking-tight text-slate-900 sm:text-3xl" data-id="element-138" data-mp="1cqbvln5lpogb">{productShortName}</h3>
                <p className="mt-2 text-sm text-slate-600" data-id="element-139" data-mp="17t3b3fwzd8bw">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-140" data-mp="20g66w0a9v4yg">
                <span className="text-sm text-slate-500" data-id="element-141" data-mp="20emr0asj2vx7">
                  Regular price: <span className="line-through decoration-2" data-id="element-142" data-mp="1vfrz8jcl1x0y">{priceBefore}</span>
                </span>
                <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-143" data-mp="1rfht96osj6m3">Today:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-bold leading-none tracking-tight text-slate-900 sm:text-6xl" data-id="element-144" data-mp="k2z9tf79lko2">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-145" data-mp="hh887911hv5f">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-slate-600" data-id="element-146" data-mp="7ju6ygnotcxp">
              {['Secure payment', 'Instant access', '7-day guarantee'].map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-147" data-mp="ckrlmj9hnoug">
                  <CheckCircle2Icon className="h-4 w-4 text-teal-700" aria-hidden="true" data-id="element-148" data-mp="3uv3cgm3qru4a" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}